import { useEffect } from "react"
import { Navigate } from "react-router-dom"
import { useAuth } from "../context/userContext"

export default function RequireAuth({ children }) {
  const { user, refreshUser } = useAuth()

  useEffect(() => {
    if (user === undefined) {
      refreshUser()
    }
  }, [user, refreshUser])

  /* ---------- Loading ---------- */
  if (user === undefined) return null

  /* ❗ Only block if truly not logged in */
  if (!user) {
    return <Navigate to="/login" replace />
  }

  return children
}
